import { createAction } from "@reduxjs/toolkit";

export const getPatientBonusesSuccess = createAction('fishka/getPatientBonusesSuccess')
export const registerInFishka = createAction('fishka/registerInFishka')
export const calculateSubscriptionBonusesSuccess = createAction('fishka/calculateSubscriptionBonusesSuccess')
export const calculateConsultationBonusesSuccess = createAction('fishka/calculateConsultationBonusesSuccess')
export const openFishka = createAction("fishka/openFishka")
export const closeFishka = createAction("fishka/closeFishka")
export const fishkaRequest = createAction('fishka/fishkaRequest')
export const moveDirectlyToRegister = createAction('fishka/moveDirectlyToRegister')